﻿var _requestInProgress = false;
$(document).ready(function () {
    if (location.hash && (location.hash.toLowerCase() == "#signup" || location.hash.toLowerCase() == "#register")) {
        OpenPopup();
    }
});

function SignUp(containerId, accessUrl, accessUrlViewMode, onValidate, onSuccess, onError) {
    var _formXml = GetFormXml($('#' + containerId));

    // Checking whether the required field validation is succcess
    if (_formXml == null) return;
    // If there already a request not yet completed then that need to stop/abort before starting new one
    if (_requestInProgress)  return;
    // Checking whether the custom validation is success
    if (onValidate) {
        if (!onValidate(_formXml)) return;
    }

    _requestInProgress = true;
    // Checking credentials using Ajax
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/agoraAccess.ashx?action=SignUp',
        data: ({ contact: _formXml }),
        dataType: 'json',
        success: function (response) {
            switch (response.Number) {
                case 100: // Success
                    if (onSuccess != null) if(onSuccess(response.Contact)) return;
                    if (!isNullOrEmpty(accessUrl) && isNullOrEmpty(accessUrlViewMode)) {
                        document.location.replace(accessUrl);
                        //location.reload(true);
                    } else if (!isNullOrEmpty(accessUrl) && !isNullOrEmpty(accessUrlViewMode) && accessUrlViewMode == 'popup') {
                        $('#PERFORM_ACTION_TRIGGER').attr('href', accessUrl);
                        ClosePopup();
                        OpenPopup();
                    } else if (isNullOrEmpty(accessUrl) && !isNullOrEmpty(accessUrlViewMode) && accessUrlViewMode == 'stay') {
                        ClosePopup();
                    } else {
                        ClosePopup();
                        location.replace(((isMultiLingual() ? '/' + getLocale() : '')) + '/dashboard/default.aspx?mode=signUp');
                    }
                    $('body').removeClass('restricted-listing');
                    break;
                case 1: // Connection Error
                    if (onError == null) alert('Unable to connect to Database!');
                    else onError(1, 'Please enter a valid Password');
                    break;
                case 2: // Execute Error
                    if (onError == null) alert('Query execution failure!');
                    else onError(2, 'Query execution failure!');
                    break;
                case 9: // Custom Error
                    if (onError == null) alert(response.Message);
                    else onError(11, response.Message);
                    break;
                case 10: // Invalid
                    if (onError == null) alert('Invalid Data. Please retry!');
                    else onError(10, 'Invalid Data. Please retry!');
                    break;
                case 11: // Duplicate
                    if (onError == null) alert('The email address you entered is already registered. Please sign in to your existing account or click "Forgot Password" for help.');
                    else onError(11, 'The email address you entered is already registered. Please sign in to your existing account or click "Forgot Password" for help.');
                    break;
                case 204:
                    ShowAlert('SMS Gateway email addresses, which send email as text messages, are not permitted. Please enter a standard email address.', 2000, 'alert_box', null);
                    break;
            }
            _requestInProgress = false;
        },
        error: function (response) {
            if (onError == null) alert('Unknown Error. Please try later!');
            else onError(99, 'Unknown Error. Please try later');
            _requestInProgress = false;
        },
        statusCode: {
            404: function () {
                alert('Service (agoraAccess) not found!');
            }
        }
    });   
}

function SignIn(containerId, accessUrl, accessUrlViewMode, onValidate, onSuccess, onError) {
    var _formXml = GetFormXml($('#' + containerId));

    // Checking whether the required field validation is succcess
    if (_formXml == null) return;

    // Checking whether the custom validation is success
    if (onValidate) {
        if (!onValidate(_formXml)) return;
    }

    // Checking credentials using Ajax
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/agoraAccess.ashx?action=SignIn',
        data: ({ contact: _formXml }),
        dataType: 'json',
        success: function (response) {
            switch (response.Number) {
                case 100: // Success
                    if (onSuccess != null) onSuccess(response.Contact);
                    if (!isNullOrEmpty(accessUrl) && isNullOrEmpty(accessUrlViewMode)) {
                        document.location.replace(accessUrl);
                    } else if (!isNullOrEmpty(accessUrl) && !isNullOrEmpty(accessUrlViewMode) && accessUrlViewMode == 'popup') {
                        $('#PERFORM_ACTION_TRIGGER').attr('href', accessUrl);
                        ClosePopup();
                        OpenPopup();
                    } else if (isNullOrEmpty(accessUrl) && !isNullOrEmpty(accessUrlViewMode) && accessUrlViewMode == 'stay') {
                        ClosePopup();
                    } else {
                        ClosePopup();
                        location.replace(((isMultiLingual() ? '/' + getLocale() : '')) + '/dashboard/default.aspx?mode=signIn');
                    }
                    $('body').removeClass('restricted-listing');
                    break;
                case 401:
                    if (onError == null) alert('Invalid email address or password. Please try again!');
                    else onError(401, 'Invalid email address or password. Please try again!');
                    break;
                case 302:
                    if (!isNullOrEmpty(response.Url)) {
                        location.href = response.Url;
                    }
                    break;
                case 1: // Connection Error
                    if (onError == null) alert('Unable to connect to Database!');
                    else onError(1, 'Please enter a valid Password');
                    break;
                case 2: // Execute Error
                    if (onError == null) alert('Query execution failure!');
                    else onError(2, 'Query execution failure!');
                    break;
                case 9: // Custom Error
                    if (onError == null) alert(response.Message);
                    else onError(11, response.Message);
                    break;
                case 10: // Invalid
                    if (onError == null) alert('Invalid email address or password. Please try again!');
                    else onError(10, 'Invalid email address or password. Please try again!');
                    break;
            }
        },
        error: function (response) {
            if (onError == null) alert('Unknown Error. Please try later!');
            else onError(99, 'Unknown Error. Please try later');
        },
        statusCode: {
            404: function () {
                alert('Service (agoraAccess) not found!');
            }
        }
    });
}

function SaveSearch(containerId, accessUrl, accessUrlViewMode, onValidate, onSuccess, onError) {
    var _formXml = GetFormXml($('#' + containerId));

    // Checking whether the required field validation is succcess
    if (_formXml == null) return;

    // Checking whether the custom validation is success
    if (onValidate) {
        if (!onValidate(_formXml)) return;
    }

    // Checking credentials using Ajax
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/agoraAccess.ashx?action=SaveSearch',
        data: ({ demand: _formXml }),
        dataType: 'json',
        success: function (response) {
            switch (response.Number) {
                case 100: // Success
                    if (onSuccess == null) alert('You have successfully saved the search');
                    else onSuccess(100, 'You have successfully saved the search');
                    ClosePopup();
                    break;
                case 1: // Connection Error
                    if (onError == null) alert('Unable to connect to Database!');
                    else onError(1, 'Please enter a valid Password');
                    break;
                case 2: // Execute Error
                    if (onError == null) alert('Query execution failure!');
                    else onError(2, 'Query execution failure!');
                    break;
                case 9: // Custom Error
                    if (onError == null) alert(response.Message);
                    else onError(11, response.Message);
                    break;
                case 10: // Invalid
                    if (onError == null) alert('Invalid email address or password. Please try again!');
                    else onError(10, 'Invalid email address or password. Please try again!');
                    break;
            }
        },
        error: function (response) {
            if (onError == null) alert('Unknown Error. Please try later!');
            else onError(99, 'Unknown Error. Please try later');
        },
        statusCode: {
            404: function () {
                alert('Service (agoraAccess) not found!');
            }
        }
    });
}

function RequestInfo(containerId, onValidate, onSuccess, onError) {
    var _formXml = GetFormXml($('#' + containerId));

    // Checking whether the required field validation is succcess
    if (_formXml == null) return;

    // Checking whether the custom validation is success
    if (onValidate) {
        if (!onValidate(_formXml)) return;
    }

    // Checking credentials using Ajax
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/agoraRequestInfo.ashx',
        data: ({ WebRequest: _formXml }),
        dataType: 'json',
        success: function (response) {
            switch (response.Number) {
                case 100: // Success
                    if (onSuccess == null) alert('Your request has been submitted successfully');
                    else onSuccess(100, 'Your request has been submitted successfully');
                    ClosePopup();
                    break;
                case 1: // Connection Error
                    if (onError == null) alert('Unable to connect to Database!');
                    else onError(1, 'Please enter a valid Password');
                    break;
                case 2: // Execute Error
                    if (onError == null) alert('Query execution failure!');
                    else onError(2, 'Query execution failure!');
                    break;
                case 9: // Custom Error
                    if (onError == null) alert(response.Message);
                    else onError(11, response.Message);
                    break;
                case 10: // Invalid
                    if (onError == null) alert('Invalid input parameters. Please try again!');
                    else onError(10, 'Invalid input parameters. Please try again!');
                    break;
            }
        },
        error: function (response) {
            if (onError == null) alert('Unknown Error. Please try later!');
            else onError(99, 'Unknown Error. Please try later');
        },
        statusCode: {
            404: function () {
                alert('Service (agoraRequestInfo) not found!');
            }
        }
    });
}

function NeighborhoodReport(containerId, onValidate, onSuccess, onError) {
    var _formXml = GetFormXml($('#' + containerId));

    // Checking whether the required field validation is succcess
    if (_formXml == null) return;

    // Checking whether the custom validation is success
    if (onValidate) {
        if (!onValidate(_formXml)) return;
    }

    // Checking credentials using Ajax
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/agoraNeighborhoodReport.ashx',
        data: ({ WebRequest: _formXml }),
        dataType: 'json',
        success: function (response) {
            switch (response.Number) {
                case 100: // Success
                    if (onSuccess == null) alert('Your Neighborhood Report request has been submitted. A report will be emailed to you within the next 24 business hours.');
                    else onSuccess(100, 'Your Neighborhood Report request has been submitted. A report will be emailed to you within the next 24 business hours.');
                    ClosePopup();
                    break;
                case 1: // Connection Error
                    if (onError == null) alert('Unable to connect to Database!');
                    else onError(1, 'Please enter a valid Password');
                    break;
                case 2: // Execute Error
                    if (onError == null) alert('Query execution failure!');
                    else onError(2, 'Query execution failure!');
                    break;
                case 9: // Custom Error
                    if (onError == null) alert(response.Message);
                    else onError(11, response.Message);
                    break;
                case 10: // Invalid
                    if (onError == null) alert('Invalid input parameters. Please try again!');
                    else onError(10, 'Invalid input parameters. Please try again!');
                    break;
            }
        },
        error: function (response) {
            if (onError == null) alert('Unknown Error. Please try later!');
            else onError(99, 'Unknown Error. Please try later');
        },
        statusCode: {
            404: function () {
                alert('Service (agoraNeighborhoodReport) not found!');
            }
        }
    });
}

function ContactMortgageSpecialist(containerId, onValidate, onSuccess, onError) {
    var _formXml = GetFormXml($('#' + containerId));

    // Checking whether the required field validation is succcess
    if (_formXml == null) return;

    // Checking whether the custom validation is success
    if (onValidate) {
        if (!onValidate(_formXml)) return;
    }

    // Checking credentials using Ajax
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/agoraContactMortgageSpecialist.ashx',
        data: ({ WebRequest: _formXml }),
        dataType: 'json',
        success: function (response) {
            switch (response.Number) {
                case 100: // Success
                    if (onSuccess == null) alert('Thank you for your request. A Mortgage Consultant will contact you shortly.');
                    else onSuccess(100, 'Thank you for your request. A Mortgage Consultant will contact you shortly.');
                    ClosePopup();
                    break;
                case 1: // Connection Error
                    if (onError == null) alert('Unable to connect to Database!');
                    else onError(1, 'Please enter a valid Password');
                    break;
                case 2: // Execute Error
                    if (onError == null) alert('Query execution failure!');
                    else onError(2, 'Query execution failure!');
                    break;
                case 9: // Custom Error
                    if (onError == null) alert(response.Message);
                    else onError(11, response.Message);
                    break;
                case 10: // Invalid
                    if (onError == null) alert('Invalid input parameters. Please try again!');
                    else onError(10, 'Invalid input parameters. Please try again!');
                    break;
            }
        },
        error: function (response) {
            if (onError == null) alert('Unknown Error. Please try later!');
            else onError(99, 'Unknown Error. Please try later');
        },
        statusCode: {
            404: function () {
                alert('Service (ContactMortgageSpecialist) not found!');
            }
        }
    });
}


function RequestShowing(containerId, onValidate, onSuccess, onError) {
    var _formXml = GetFormXml($('#' + containerId));

    // Checking whether the required field validation is succcess
    if (_formXml == null) return;

    // Checking whether the custom validation is success
    if (onValidate) {
        if (!onValidate(_formXml)) return;
    }

    // Checking credentials using Ajax
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/agoraRequestShowing.ashx',
        data: ({ WebRequest: _formXml }),
        dataType: 'json',
        success: function (response) {
            switch (response.Number) {
                case 100: // Success
                    if (onSuccess == null) alert('Your request has been submitted successfully');
                    else onSuccess(100, 'Your request has been submitted successfully');
                    ClosePopup();
                    break;
                case 1: // Connection Error
                    if (onError == null) alert('Unable to connect to Database!');
                    else onError(1, 'Please enter a valid Password');
                    break;
                case 2: // Execute Error
                    if (onError == null) alert('Query execution failure!');
                    else onError(2, 'Query execution failure!');
                    break;
                case 9: // Custom Error
                    if (onError == null) alert(response.Message);
                    else onError(11, response.Message);
                    break;
                case 10: // Invalid
                    if (onError == null) alert('Invalid input parameters. Please try again!');
                    else onError(10, 'Invalid input parameters. Please try again!');
                    break;
            }
        },
        error: function (response) {
            if (onError == null) alert('Unknown Error. Please try later!');
            else onError(99, 'Unknown Error. Please try later');
        },
        statusCode: {
            404: function () {
                alert('Service (agoraRequestShowing) not found!');
            }
        }
    });
}

function TextListing(containerId, onValidate, onSuccess, onError) {
    var _formXml = GetFormXml($('#' + containerId));

    // Checking whether the required field validation is succcess
    if (_formXml == null) return;

    // Checking whether the custom validation is success
    if (onValidate) {
        if (!onValidate(_formXml)) return;
    }

    // Checking credentials using Ajax
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/agoraTextListing.ashx',
        data: ({ WebRequest: _formXml }),
        dataType: 'json',
        success: function (response) {
            switch (response.Number) {
                case 100: // Success
                    if (onSuccess == null) alert('Your request has been submitted successfully');
                    else onSuccess(100, 'Your request has been submitted successfully');
                    ClosePopup();
                    break;
                case 1: // Connection Error
                    if (onError == null) alert('Unable to connect to Database!');
                    else onError(1, 'Please enter a valid Password');
                    break;
                case 2: // Execute Error
                    if (onError == null) alert('Query execution failure!');
                    else onError(2, 'Query execution failure!');
                    break;
                case 9: // Custom Error
                    if (onError == null) alert(response.Message);
                    else onError(11, response.Message);
                    break;
                case 10: // Invalid
                    if (onError == null) alert('Invalid input parameters. Please try again!');
                    else onError(10, 'Invalid input parameters. Please try again!');
                    break;
            }
        },
        error: function (response) {
            if (onError == null) alert('Unknown Error. Please try later!');
            else onError(99, 'Unknown Error. Please try later');
        },
        statusCode: {
            404: function () {
                alert('Service (agoraTextListing) not found!');
            }
        }
    });
}

function EmailListing(containerId, onValidate, onSuccess, onError) {
    var _formXml = GetFormXml($('#' + containerId));

    // Checking whether the required field validation is succcess
    if (_formXml == null) return;

    // Checking whether the custom validation is success
    if (onValidate) {
        if (!onValidate(_formXml)) return;
    }

    // Checking credentials using Ajax
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/agoraEmailListing.ashx',
        data: ({ WebRequest: _formXml }),
        dataType: 'json',
        success: function (response) {
            switch (response.Number) {
                case 100: // Success
                    if (onSuccess == null) alert('The property details has been sent successfully');
                    else onSuccess(100, 'The property details has been sent successfully');
                    ClosePopup();
                    break;
                case 1: // Connection Error
                    if (onError == null) alert('Unable to connect to Database!');
                    else onError(1, 'Please enter a valid Password');
                    break;
                case 2: // Execute Error
                    if (onError == null) alert('Query execution failure!');
                    else onError(2, 'Query execution failure!');
                    break;
                case 9: // Custom Error
                    if (onError == null) alert(response.Message);
                    else onError(11, response.Message);
                    break;
                case 10: // Invalid
                    if (onError == null) alert('Invalid input parameters. Please try again!');
                    else onError(10, 'Invalid input parameters. Please try again!');
                    break;
            }
        },
        error: function (response) {
            if (onError == null) alert('Unknown Error. Please try later!');
            else onError(99, 'Unknown Error. Please try later');
        },
        statusCode: {
            404: function () {
                alert('Service (agoraEmailListing) not found!');
            }
        }
    });
}

function ContactUs(containerId, onValidate, onSuccess, onError, contactType) {
    var $form = $('#' + containerId);
    var _formXml = GetFormXml($form);

    // Checking whether the required field validation is succcess
    if (_formXml == null) return;

    // Checking whether the custom validation is success
    if (onValidate) {
        if (!onValidate(_formXml)) return;
    }

    // Checking credentials using Ajax
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/agoraContactUs.ashx',
        data: ({ WebRequest: _formXml, ContactType: contactType }),
        dataType: 'json',
        success: function (response) {
            switch (response.Number) {
                case 100: // Success
                    if (onSuccess == null) alert('Your request has been submitted successfully');
                    else onSuccess(100, 'Your request has been submitted successfully');
                    ClosePopup();
                    break;
                case 1: // Connection Error
                    if (onError == null) alert('Unable to connect to Database!');
                    else onError(1, 'Please enter a valid Password');
                    break;
                case 2: // Execute Error
                    if (onError == null) alert('Query execution failure!');
                    else onError(2, 'Query execution failure!');
                    break;
                case 9: // Custom Error
                    if (onError == null) alert(response.Message);
                    else onError(11, response.Message);
                    break;
                case 10: // Invalid
                    if (onError == null) alert('Invalid input parameters. Please try again!');
                    else onError(10, 'Invalid input parameters. Please try again!');
                    break;
            }
        },
        error: function (response) {
            if (onError == null) alert('Unknown Error. Please try later!');
            else onError(99, 'Unknown Error. Please try later');
        },
        statusCode: {
            401: function () {
                try {
                    $form.find('[data-captcha-reload]').trigger('click');
                } catch (e) { }
            },
            404: function () {
                alert('Service (agoraContactUs) not found!');
            }
        }
    });
}


function SellAHome(containerId, onValidate, onSuccess, onError) {
    var _formXml = GetFormXml($('#' + containerId));

    // Checking whether the required field validation is succcess
    if (_formXml == null) return;

    // Checking whether the custom validation is success
    if (onValidate) {
        if (!onValidate(_formXml)) return;
    }

    // Checking credentials using Ajax
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/agoraSellAHome.ashx',
        data: ({ WebRequest: _formXml }),
        dataType: 'json',
        success: function (response) {
            switch (response.Number) {
                case 100: // Success
                    if (onSuccess == null) alert('Your request has been submitted successfully');
                    else onSuccess(100, 'Your request has been submitted successfully');
                    ClosePopup();
                    break;
                case 1: // Connection Error
                    if (onError == null) alert('Unable to connect to Database!');
                    else onError(1, 'Please enter a valid Password');
                    break;
                case 2: // Execute Error
                    if (onError == null) alert('Query execution failure!');
                    else onError(2, 'Query execution failure!');
                    break;
                case 9: // Custom Error
                    if (onError == null) alert(response.Message);
                    else onError(11, response.Message);
                    break;
                case 10: // Invalid
                    if (onError == null) alert('Invalid input parameters. Please try again!');
                    else onError(10, 'Invalid input parameters. Please try again!');
                    break;
            }
        },
        error: function (response) {
            if (onError == null) alert('Unknown Error. Please try later!');
            else onError(99, 'Unknown Error. Please try later');
        },
        statusCode: {
            404: function () {
                alert('Service (agoraContactUs) not found!');
            }
        }
    });
}

function MaintenanceService(containerId, onValidate, onSuccess, onError) {
    var _formXml = GetFormXml($('#' + containerId));

    // Checking whether the required field validation is succcess
    if (_formXml == null) return;

    // Checking whether the custom validation is success
    if (onValidate) {
        if (!onValidate(_formXml)) return;
    }

    // Checking credentials using Ajax
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/MaintenanceService.ashx',
        data: ({ WebRequest: _formXml }),
        dataType: 'json',
        success: function (response) {
            switch (response.Number) {
                case 100: // Success
                    if (onSuccess == null) alert('Your request has been submitted successfully');
                    else onSuccess(100, 'Your request has been submitted successfully');
                    ClosePopup();
                    break;
                case 1: // Connection Error
                    if (onError == null) alert('Unable to connect to Database!');
                    else onError(1, 'Please enter a valid Password');
                    break;
                case 2: // Execute Error
                    if (onError == null) alert('Query execution failure!');
                    else onError(2, 'Query execution failure!');
                    break;
                case 9: // Custom Error
                    if (onError == null) alert(response.Message);
                    else onError(11, response.Message);
                    break;
                case 10: // Invalid
                    if (onError == null) alert('Invalid input parameters. Please try again!');
                    else onError(10, 'Invalid input parameters. Please try again!');
                    break;
            }
        },
        error: function (response) {
            if (onError == null) alert('Unknown Error. Please try later!');
            else onError(99, 'Unknown Error. Please try later');
        },
        statusCode: {
            404: function () {
                alert('Service (agoraContactUs) not found!');
            }
        }
    });
}

function OrderReloc(containerId, onValidate, onSuccess, onError) {
    var _formXml = GetFormXml($('#' + containerId));

    // Checking whether the required field validation is succcess
    if (_formXml == null) return;

    // Checking whether the custom validation is success
    if (onValidate) {
        if (!onValidate(_formXml)) return;
    }

    // Checking credentials using Ajax
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/agoraOrderReloc.ashx',
        data: ({ WebRequest: _formXml }),
        dataType: 'json',
        success: function (response) {
            switch (response.Number) {
                case 100: // Success
                    if (onSuccess == null) alert('Your request has been submitted successfully');
                    else onSuccess(100, 'Your request has been submitted successfully');
                    ClosePopup();
                    break;
                case 1: // Connection Error
                    if (onError == null) alert('Unable to connect to Database!');
                    else onError(1, 'Please enter a valid Password');
                    break;
                case 2: // Execute Error
                    if (onError == null) alert('Query execution failure!');
                    else onError(2, 'Query execution failure!');
                    break;
                case 9: // Custom Error
                    if (onError == null) alert(response.Message);
                    else onError(11, response.Message);
                    break;
                case 10: // Invalid
                    if (onError == null) alert('Invalid input parameters. Please try again!');
                    else onError(10, 'Invalid input parameters. Please try again!');
                    break;
            }
        },
        error: function (response) {
            if (onError == null) alert('Unknown Error. Please try later!');
            else onError(99, 'Unknown Error. Please try later');
        },
        statusCode: {
            404: function () {
                alert('Service (agoraOrderReloc) not found!');
            }
        }
    });
}



function ForgotPassword(containerId, onValidate, onSuccess, onError) {
    var _formXml = GetFormXml($('#' + containerId));

    // Checking whether the required field validation is succcess
    if (_formXml == null) return;

    // Checking whether the custom validation is success
    if (onValidate) {
        if (!onValidate(_formXml)) return;
    }

    // Checking credentials using Ajax
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/agoraForgotPassword.ashx',
        data: ({ Contact: _formXml }),
        dataType: 'json',
        success: function (response) {
            switch (response.Number) {
                case 100: // Success
                    if (onSuccess == null) alert('Please check your email shortly for instructions on resetting your password.');
                    else onSuccess(100, 'Please check your email shortly for instructions on resetting your password.');
                    ClosePopup();
                    break;
                case 1: // Connection Error
                    if (onError == null) alert('Unable to connect to Database!');
                    else onError(1, 'Please enter a valid Password');
                    break;
                case 2: // Execute Error
                    if (onError == null) alert('Query execution failure!');
                    else onError(2, 'Query execution failure!');
                    break;
                case 9: // Custom Error
                    if (onError == null) alert(response.Message);
                    else onError(11, response.Message);
                    break;
                case 10: // Invalid
                    if (onError == null) alert('An account with that email address cannot be found. Please try again.');
                    else onError(10, 'An account with that email address cannot be found. Please try again.');
                    break;
            }
        },
        error: function (response) {
            if (onError == null) alert('Unknown Error. Please try later!');
            else onError(99, 'Unknown Error. Please try later');
        },
        statusCode: {
            404: function () {
                alert('Service (ForgotPassword) not found!');
            }
        }
    });
}


function CompanyNewsLetter(containerId, onValidate, onSuccess, onError) {
    var _formXml = GetFormXml($('#' + containerId));

    // Checking whether the required field validation is succcess
    if (_formXml == null) return;

    // Checking whether the custom validation is success
    if (onValidate) {
        if (!onValidate(_formXml)) return;
    }


    // Checking credentials using Ajax
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/agoraCompanyNewsLetter.ashx',
        data: ({ WebRequest: _formXml }),
        dataType: 'json',
        success: function (response) {
            switch (response.Number) {
                case 100: // Success
                    if (onSuccess == null) alert('You have registered for newsletter successfully');
                    else onSuccess(100, 'You have registered for newsletter successfully');
                    ClosePopup();
                    break;
                case 1: // Connection Error
                    if (onError == null) alert('Unable to connect to Database!');
                    else onError(1, 'Please enter a valid Password');
                    break;
                case 2: // Execute Error
                    if (onError == null) alert('Query execution failure!');
                    else onError(2, 'Query execution failure!');
                    break;
                case 9: // Custom Error
                    if (onError == null) alert(response.Message);
                    else onError(11, response.Message);
                    break;
                case 10: // Invalid
                    if (onError == null) alert('Invalid input parameters. Please try again!');
                    else onError(10, 'Invalid input parameters. Please try again!');
                    break;
            }
        },
        error: function (response) {
            if (onError == null) alert('Unknown Error. Please try later!');
            else onError(99, 'Unknown Error. Please try later');
        },
        statusCode: {
            404: function () {
                alert('Service (agoraEmailListing) not found!');
            }
        }
    });
}


function EmailFriend(containerId, onValidate, onSuccess, onError) {
    var _formXml = GetFormXml($('#' + containerId));

    // Checking whether the required field validation is succcess
    if (_formXml == null) return;

    // Checking whether the custom validation is success
    if (onValidate) {
        if (!onValidate(_formXml)) return;
    }

    // Checking credentials using Ajax
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/agoraEmailFriend.ashx',
        data: ({ WebRequest: _formXml }),
        dataType: 'json',
        success: function (response) {
            switch (response.Number) {
                case 100: // Success
                    if (onSuccess == null) alert('The details has been sent successfully');
                    else onSuccess(100, 'The details has been sent successfully');
                    ClosePopup();
                    break;
                case 1: // Connection Error
                    if (onError == null) alert('Unable to connect to Database!');
                    else onError(1, 'Please enter a valid Password');
                    break;
                case 2: // Execute Error
                    if (onError == null) alert('Query execution failure!');
                    else onError(2, 'Query execution failure!');
                    break;
                case 9: // Custom Error
                    if (onError == null) alert(response.Message);
                    else onError(11, response.Message);
                    break;
                case 10: // Invalid
                    if (onError == null) alert('Invalid input parameters. Please try again!');
                    else onError(10, 'Invalid input parameters. Please try again!');
                    break;
            }
        },
        error: function (response) {
            if (onError == null) alert('Unknown Error. Please try later!');
            else onError(99, 'Unknown Error. Please try later');
        },
        statusCode: {
            404: function () {
                alert('Service (agoraEmailListing) not found!');
            }
        }
    });
}

function UpdateUserArea(html) {
    $('#DIV_USER_AREA').html(html);
}

function PerformAction(action, queryString) {
    var _accessUrl = '';
    var _accessFireWall = ((isMultiLingual() ? '/' + getLocale() : '')) + '/dashboard/Access.aspx';

    if (action != 'SignUp' && action != 'SignIn' && action != 'MarketTrends') {
        if (!IsSignedIn()) {
            _accessUrl = _accessFireWall + '?view=popup&accessUrl=' + escape('/dashboard/' + action + '.aspx');
            if (!isNullOrEmpty(queryString)) _accessUrl += '?' + escape(queryString);
        } else {
            _accessUrl = ((isMultiLingual() ? '/' + getLocale() : '')) + '/dashboard/' + action + '.aspx';
            if (!isNullOrEmpty(queryString)) _accessUrl += '?' + queryString;
        }
    } else if (action == 'MarketTrends') {
        _accessUrl = '/dashboard/MarketTrends.aspx?' + queryString;
    } else {
        _accessUrl = _accessFireWall;
        if (!isNullOrEmpty(queryString)) _accessUrl += '?' + queryString;
    }

    $('#PERFORM_ACTION_TRIGGER').attr('href', _accessUrl);
    $('#PERFORM_ACTION_TRIGGER').trigger('click');
}

function IsSignedIn() {
    if (isNullOrEmpty($('#CONTACT_GUID'))) return false;
    if (isNullOrEmpty($('#CONTACT_GUID').val())) return false;
    if ($('#CONTACT_GUID').val().length != 36) return false;
    return true;
}

function ContactOffice(email) {
    $.ajax({
        type: 'POST',
        url: ((isMultiLingual() ? '/' + getLocale() : '')) + '/services/agoraContactOffice.ashx',
        data: ({
            Name: $("#textname").val(),
            Email: $("#txtEmail").val(),
            ToEmail: email,
            Subject: $("#textsubject").val(),
            comment: $("#textmsg").val()
        }),
        dataType: 'text',
        success: function (response) {
            if (response == "100") {
                alert('Your request has been submitted successfully');
                ClosePopup();
            }
        },
        error: function (response) {
            if (onError == null) alert('Unknown Error. Please try later!');
            else onError(99, 'Unknown Error. Please try later');
        },
        statusCode: {
            404: function () {
                alert('Service (agoraContactUs) not found!');
            }
        }
    });
}